import { AngularExecution } from './angular-core';
import { AsyncEventComponent } from './components/async-event/async-event.component';
import { AsyncGuestComponent } from './components/async-guest/async-guest.component';

/**
 * Angular App
 */
@AngularExecution({
  'asyncEventComponent': AsyncEventComponent,
  'asyncGuestComponent': AsyncGuestComponent
})
export class AngularApp { }
